import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { TokenStorageService } from 'src/app/util/services/token-storage.service';
import { Router } from '@angular/router';
import { CartService } from 'src/app/util/services/cart.service';
import { take } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
// import { Languages } from 'src/app/util/settings/languages';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy{
  @Input() public isLoggedIn: boolean;
  @Input() public showAdminBoard: boolean;
  @Input() public showManagerBoard: boolean;
  @Input() public showUserBoard: boolean;
  @Input() public username: string;

  numberElements: number;

  languages = [
    {value: 'es', viewValue: 'Español'},
    {value: 'pt', viewValue: 'Portugués'}
  ];


  languageSelected = this.languages[0].value;
  sub: Subscription;


  constructor(
    private tokenService: TokenStorageService,
    private router: Router,
    private cartService: CartService,
    private translate: TranslateService) {
      translate.setDefaultLang(this.languageSelected);
    }

  useLanguage() {
    // this.translate
    // .stream(this.languageSelected)
    // .subscribe(v => console.log(v));
    this.translate.use(this.languageSelected);
  }

  ngOnInit(): void {
  this.sub = this.cartService.elementsSubject$.subscribe(data => {
      this.numberElements = data.length;
      if(localStorage.getItem('products')){
        const products = JSON.parse(localStorage.getItem('products'));
        this.numberElements = products.length;
      }
    });
  }

  logout() {
    this.tokenService.signOut();
    window.location.reload();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

}
